import { render, staticRenderFns } from "./Terminado.vue?vue&type=template&id=42f79806"
import script from "./Terminado.vue?vue&type=script&lang=js"
export * from "./Terminado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42f79806')) {
      api.createRecord('42f79806', component.options)
    } else {
      api.reload('42f79806', component.options)
    }
    module.hot.accept("./Terminado.vue?vue&type=template&id=42f79806", function () {
      api.rerender('42f79806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificacionesdigital/Terminado.vue"
export default component.exports